module.exports = __webpack_public_path__ + "img/goods-h.dfcc821b.svg";